import { mediaUrl } from "../../../utils/clientHeroTheme";
import aa from "../AdminPortal/adminApp.module.css";
import { DatePicker, Field, Input, Textarea, TimePicker } from "../../ui";
import TimePresetChips from "./TimePresetChips";

export default function CompetitionDetailsFields({
  form,
  onChange,
  sessionId,
  coverPreviewUrl,
  onCoverUpload,
  onCoverFileSelect,
  coverUploading,
  sheet = false,
}) {
  const coverSrc =
    coverPreviewUrl ||
    (form.cover_image_url ? mediaUrl(form.cover_image_url) : null);

  const handleFile = (file) => {
    if (!file) return;
    if (sessionId && onCoverUpload) {
      onCoverUpload(file);
      return;
    }
    onCoverFileSelect?.(file);
  };

  const dateClass = sheet ? aa.calSlotDateInput : undefined;
  const timeClass = sheet ? aa.calSlotTimeInput : undefined;
  const rowClass = sheet ? aa.calSlotEditRow : aa.competitionDetailsRow;
  const scheduleWrapClass = sheet ? aa.calSlotScheduleFields : "";

  return (
    <div className={aa.competitionDetailsForm}>
      <div className={aa.competitionCoverBlock}>
        <label
          className={`${aa.competitionCoverPreview} ${
            coverSrc ? aa.competitionCoverPreviewFilled : ""
          }`}
          style={coverSrc ? { backgroundImage: `url(${coverSrc})` } : undefined}
        >
          <input
            type="file"
            accept="image/jpeg,image/png,image/webp"
            hidden
            disabled={coverUploading}
            onChange={(e) => {
              const file = e.target.files?.[0];
              handleFile(file);
              e.target.value = "";
            }}
          />
          <div className={aa.competitionCoverOverlay}>
            {!coverSrc ? (
              <>
                <span className={aa.competitionCoverIcon} aria-hidden>
                  <svg viewBox="0 0 24 24">
                    <path
                      d="M4 16l4.5-5 3.5 4 2.5-3L20 18"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <rect
                      x="3"
                      y="5"
                      width="18"
                      height="14"
                      rx="2.5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.75"
                    />
                    <circle cx="8.5" cy="10" r="1.5" fill="currentColor" />
                  </svg>
                </span>
                <strong>Добавить обложку</strong>
                <span>JPG, PNG или WebP</span>
              </>
            ) : (
              <strong>{coverUploading ? "Загрузка…" : "Сменить обложку"}</strong>
            )}
          </div>
        </label>
        {!sessionId && coverSrc ? (
          <p className={aa.competitionCoverHint}>
            Обложка сохранится вместе с событием
          </p>
        ) : null}
      </div>

      <div className={aa.competitionDetailsSection}>
        <p className={aa.competitionDetailsSectionTitle}>Площадка</p>
        <Field label="Площадка">
          <Input
            value={form.venue_name}
            onChange={(e) => onChange({ venue_name: e.target.value })}
            placeholder="Название арены или спорткомплекса"
          />
        </Field>

        <Field label="Адрес">
          <Textarea
            rows={2}
            value={form.venue_address}
            onChange={(e) => onChange({ venue_address: e.target.value })}
            placeholder="Город, улица, как добраться"
          />
        </Field>
      </div>

      <div className={aa.competitionDetailsSection}>
        <p className={aa.competitionDetailsSectionTitle}>Сбор участников</p>
        <div className={scheduleWrapClass}>
          <div className={rowClass}>
            <Field label="Дата">
              <DatePicker
                value={form.assembly_date}
                onChange={(assembly_date) => onChange({ assembly_date })}
                className={dateClass}
              />
            </Field>
            <Field label="Время">
              <TimePicker
                value={form.assembly_time}
                onChange={(assembly_time) => onChange({ assembly_time })}
                className={timeClass}
                step={300}
              />
            </Field>
          </div>
          {sheet ? (
            <TimePresetChips
              value={form.assembly_time}
              onChange={(assembly_time) => onChange({ assembly_time })}
              label="Время сбора"
            />
          ) : null}
        </div>
      </div>

      <div className={aa.competitionDetailsSection}>
        <p className={aa.competitionDetailsSectionTitle}>Для участников</p>
        <Field label="Информация">
          <Textarea
            rows={4}
            value={form.event_description}
            onChange={(e) => onChange({ event_description: e.target.value })}
            placeholder="Регламент, форма, что взять с собой, весовая…"
          />
        </Field>

        <Field label="Контакт организатора">
          <Input
            value={form.contact_info}
            onChange={(e) => onChange({ contact_info: e.target.value })}
            placeholder="Телефон, Telegram, ответственный"
          />
        </Field>
      </div>
    </div>
  );
}
